import styles from "./CategoryChips.module.css";

export type CategoryFilter =
  | "all"
  | "tutorial"
  | "concept"
  | "troubleshooting"
  | "update"
  | "inspiration";

type ChipDef = {
  value: CategoryFilter;
  label: string;
};

const CHIPS: ReadonlyArray<ChipDef> = [
  { value: "all", label: "All" },
  { value: "tutorial", label: "Tutorials" },
  { value: "concept", label: "Concepts" },
  { value: "troubleshooting", label: "Troubleshooting" },
  { value: "update", label: "Updates" },
  { value: "inspiration", label: "Inspiration" },
];

type Props = {
  active: CategoryFilter;
  counts: Record<CategoryFilter, number>;
  onChange: (next: CategoryFilter) => void;
};

export const CategoryChips = ({ active, counts, onChange }: Props): JSX.Element | null => {
  const visible = CHIPS.filter((chip) => chip.value === "all" || counts[chip.value] > 0);
  if (visible.length <= 1) return null;
  return (
    <div
      className={styles.row}
      role="tablist"
      aria-label="Filter resources by category"
    >
      {visible.map((chip) => {
        const isActive = chip.value === active;
        const count = counts[chip.value];
        return (
          <button
            key={chip.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.chip} ${isActive ? styles.chipActive : ""}`}
            onClick={() => onChange(chip.value)}
          >
            {chip.label}
            <span className={styles.count}>{count}</span>
          </button>
        );
      })}
    </div>
  );
};
